export type TableSortDirection = 'asc' | 'desc';

type TableSortingState = Array<{ id: string; desc: boolean }>;

export const sortingFromTableSort = (current: { sort?: string; direction?: TableSortDirection }): TableSortingState =>
  current.sort ? [{ id: current.sort, desc: current.direction === 'desc' }] : [];

export const tableSortFromSorting = (sorting: TableSortingState): { sort?: string; direction?: TableSortDirection } => ({
  sort: sorting[0]?.id,
  direction: sorting[0] ? (sorting[0].desc ? 'desc' : 'asc') : undefined,
});

/** A cleared sort omits both request parameters so the endpoint uses its default order. */
export const nextTableSort = (
  current: { sort?: string; direction?: TableSortDirection },
  field: string,
): { sort?: string; direction?: TableSortDirection } => {
  if (current.sort !== field) return { sort: field, direction: 'asc' };
  if (current.direction === 'asc') return { sort: field, direction: 'desc' };
  return { sort: undefined, direction: undefined };
};
